export default __webpack_public_path__ + "static/media/qa-arrow_back.df4b75a0.svg";